module.exports = __webpack_public_path__ + "static/img/05942491.1f5d8662.png";